import { CartLine } from "../CartContext";
import QtyStepper from "./QtyStepper";

interface Props {
  line: CartLine;
  onIncrement: () => void;
  onDecrement: () => void;
}

const getCartPrice = (line: CartLine) => {
  const price = Number(line.dish.price || 0);
  const grossPrice = Number(line.dish.gross_price ?? price);
  return grossPrice > 0 && grossPrice < price ? grossPrice : price;
};

const CartLineItem = ({ line, onIncrement, onDecrement }: Props) => {
  const { dish, quantity } = line;
  const currency = dish.currency ?? "₹";
  const cartPrice = getCartPrice(line);

  return (
    <div className="flex items-center justify-between gap-3 px-3 py-3">
      <div className="flex flex-col gap-1.5 min-w-0">
        <p className="font-sansation font-bold text-[#111] text-[12px]">
          Dish Code : {dish.code}
        </p>
        <p className="font-opensans text-[14px] text-[rgba(17,17,17,0.8)] truncate">
          {dish.name}
        </p>
        <p className="font-sansation font-bold text-[#111] text-[16px]">
          {currency} {(cartPrice * quantity).toFixed(2)}
        </p>
        {line.note && (
          <p className="font-opensans text-[12px] text-[#8F9098] italic">
            "{line.note}"
          </p>
        )}
      </div>
      <QtyStepper
        value={quantity}
        onIncrement={onIncrement}
        onDecrement={onDecrement}
        min={1}
      />
    </div>
  );
};

export default CartLineItem;
